import * as types from "./mutation-types";

export const store = ({ commit }, data) => {
  commit(types.EXPENSES_STORE, data);
};

export const destroy = ({ commit }) => {
  commit(types.EXPENSES_DESTROY);
};

export default {
  store,
  destroy,
};
